import React from 'react';
import DataManager from '../Managers/Data';
import TranslationManager from '../Managers/Translation';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import CardsTotalsReport from '../Views/CardsTotals';

import DatePicker from "../Components/DatePicker";
import "react-datepicker/dist/react-datepicker.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./table-responsive.css";


export default class BusyTable extends React.Component {
    static contextType = DataManager.Context;

    state = {
        cards: [],
        dateFrom: new Date()
        , dateTo: new Date()
        , sortDirections: { "group": "asc", "date": "asc" }
        , sortHistory: ["date", "group"]
    }

    constructor(props) {
        super(props);
        this.handleOpenCard = this.handleOpenCard.bind(this);
        this.getCardRow = this.getCardRow.bind(this);
    }

    componentDidMount() {
        this.refreshList();

        this.refreshListInterval = setInterval(() => this.refreshList(), 10 * 1000);
    }

    refreshList() {
        this.context.fetchBusyCardList((list) => this.setState({ cards: list }));
    }

    lastSortColumn() {
        return this.state.sortHistory && this.state.sortHistory.length > 0 ? this.state.sortHistory[this.state.sortHistory.length - 1] : null;
    }


    handleSort = (column) => {
        this.setState((previousState) => ({

            sortHistory: previousState.sortHistory.filter(item => item !== column).concat(column),
            sortDirections: {
                ...previousState.sortDirections,
                [column]: previousState.sortDirections[column] === "asc"
                    ? "desc"
                    : "asc"
            }
        }));
    };

    handleOpenCard = (cardNumber) => {
        window.open("/app/cards?card=" + encodeURIComponent(cardNumber), "_blank");
    }

    getSortedCards = () => {
        const { cards, sortDirections } = this.state;

        let sortedCards = cards;
        for (let sortColumn of this.state.sortHistory) {
            const directionMultiplier = sortDirections[sortColumn] === "asc" ? 1 : -1;
            sortedCards = [...sortedCards].sort((a, b) => { // !!! we require a stable sort (keeping the ordering if sorting by multiple columns); JS sort is stable in modern browsers: https://www.geeksforgeeks.org/javascript/is-javascript-array-sort-stable/

                let aHistory = a.history ?? [];
                aHistory = aHistory.filter(item => item.toDate === null || item.toDate === undefined);
                let bHistory = b.history ?? [];
                bHistory = bHistory.filter(item => item.toDate === null || item.toDate === undefined);

                let comparison;

                if (sortColumn === "date") {
                    let aDate = new Date(0);
                    if (aHistory.length > 0 && aHistory[aHistory.length - 1].fromDate) {
                        aDate = new Date(aHistory[aHistory.length - 1].fromDate);
                    }
                    let bDate = new Date(0);
                    if (bHistory && bHistory.length > 0 && bHistory[bHistory.length - 1].fromDate) {
                        bDate = new Date(bHistory[bHistory.length - 1].fromDate);
                    }
                    comparison = aDate - bDate;
                }
                else
                    if (sortColumn === "who" || sortColumn === "group") {
                        let aVal = "";
                        if (aHistory.length > 0 && aHistory[aHistory.length - 1][sortColumn]) {
                            aVal = aHistory[aHistory.length - 1][sortColumn];
                        }
                        let bVal = "";
                        if (bHistory && bHistory.length > 0 && bHistory[bHistory.length - 1][sortColumn]) {
                            bVal = bHistory[bHistory.length - 1][sortColumn];
                        }
                        comparison = aVal.localeCompare(bVal);
                    }
                    else {
                        comparison = String(a[sortColumn]).localeCompare(String(b[sortColumn]));
                    }

                return comparison * directionMultiplier;
            });
        }

        return sortedCards;
    };

    getSortIcon = (column) => {
        let sortColumn = this.lastSortColumn();
        if (sortColumn !== column) return " ↕";
        let sortDirection = this.state.sortDirections[column];
        if (!sortDirection)
            return " ↕";
        return sortDirection === "asc" ? " ▲" : " ▼";
    };

    getCardRow(card) {

        if (!card.history || card.history.length === 0) return (
            <tr>
                <td>Error: The card {card.number} has no history available.</td>
            </tr>
        );

        
        let history = card.history ?? [];
        history = history.filter(item => item.toDate === null || item.toDate === undefined);
        if (history.length === 0) return (
            <tr>
                <td>Error: The card {card.number} is not on hands.</td>
            </tr>
        );

        let lastHistory = history[history.length - 1];
        let date = "??";
        if (lastHistory.fromDate) {
            date = new Date(lastHistory.fromDate);
            var monthNames = [
                "January", "February", "March",
                "April", "May", "June", "July",
                "August", "September", "October",
                "November", "December"
            ];

            var day = date.getDay();
            var monthIndex = date.getMonth();
            var year = date.getFullYear();

            date = (day + 1) + " " + monthNames[monthIndex] + " " + year;
        }

        let myThis = this;
        return (
            <tr key={card.number} role="button"
                onClick={() => { myThis.handleOpenCard(card.number) }}
                style={{ cursor: "pointer" }}>
                <td>{card.number}</td><td>{card.description}</td><td>{lastHistory.who}</td><td>{lastHistory.group}</td><td>{date + ""}</td>
            </tr>
        )
    }

    render() {
        return (
            <TranslationManager.Context.Consumer>
                {(translationContext) => (

                    <div className="container table-responsive mt-4"
                        style={{
                            maxHeight: "calc(100vh - 100px)",
                            overflowY: "auto"
                        }}>
                        {/* <div className="container mt-4" style={{overflowY: "scroll"}}> */}
                        <table className="table table-striped table-hover table-bordered mb-0" >
                            <thead className="table-dark">
                                <tr>
                                    <th
                                        role="button"
                                        onClick={() => this.handleSort("number")}
                                        style={{ cursor: "pointer" }}
                                    >
                                        {translationContext.getTranslation("$busy_card#")}{this.getSortIcon("number")}
                                    </th>

                                    <th
                                        role="button"
                                        onClick={() => this.handleSort("description")}
                                        style={{ cursor: "pointer" }}
                                    >
                                        {translationContext.getTranslation("$busy_description")}{this.getSortIcon("description")}
                                    </th>

                                    <th
                                        role="button"
                                        onClick={() => this.handleSort("who")}
                                        style={{ cursor: "pointer" }}
                                    >
                                        {translationContext.getTranslation("$busy_who")}{this.getSortIcon("who")}
                                    </th>

                                    <th
                                        role="button"
                                        onClick={() => this.handleSort("group")}
                                        style={{ cursor: "pointer" }}
                                    >
                                        {translationContext.getTranslation("$busy_group")}{this.getSortIcon("group")}
                                    </th>

                                    <th
                                        role="button"
                                        onClick={() => this.handleSort("date")}
                                        style={{ cursor: "pointer" }}
                                    >
                                        {translationContext.getTranslation("$busy_date")}{this.getSortIcon("date")}
                                    </th>

                                </tr>
                            </thead>

                            <tbody>
                                {this.getSortedCards().map(this.getCardRow)}
                            </tbody>
                        </table>
                    </div>
                )}
            </TranslationManager.Context.Consumer>
        );
    }
}
